<div class="notification_settings_container" [attr.data-testid]="testIds.notificationSettingsContainer">
  <!------- TODO: Im Realease 1.0 nicht benötigt daher auskommentiert
  <app-settings-slider
    [(modelNg)]="
      settingsoriginator.state.eventNotificationConfigurations.isActivated
    "
    [choiceDescriptor]="
      settingsoriginator.state.eventNotificationConfigurations.isActivated
        ? 'aktiv'
        : 'inaktiv'
    "
    settingDescriptor="1. Benachrichtigung für Raum-Events">
    <app-tooltip-icon
      class="tooltip"
      [infoText]="infoText"
      [infoTitle]="infoTitle"></app-tooltip-icon>
  </app-settings-slider>
   INFO: Hat noch keine Funktion
  <div class="notification-events">
    <div class="setting-container">
      <p class="setting-descriptor">Für Einladungen</p>
      <div class="item-container">
        <mat-checkbox
          [(ngModel)]="
            settingsoriginator.state.eventNotificationConfigurations.forInvites
              .viaMail
          "
          [disabled]="
            !settingsoriginator.state.eventNotificationConfigurations
              .isActivated
          "
          class="tim-checkbox"
          >per e-Mail
        </mat-checkbox>
        <mat-checkbox
          [(ngModel)]="
            settingsoriginator.state.eventNotificationConfigurations.forInvites
              .viaTaskManagment
          "
          [disabled]="
            !settingsoriginator.state.eventNotificationConfigurations
              .isActivated
          "
          class="tim-checkbox"
          >Aufgabenmanagement
        </mat-checkbox>
      </div>
    </div>
    <div class="setting-container">
      <p class="setting-descriptor">Für Nachrichten</p>
      <div class="item-container">
        <mat-checkbox
          [(ngModel)]="
            settingsoriginator.state.eventNotificationConfigurations.forMessages
              .viaMail
          "
          [disabled]="
            !settingsoriginator.state.eventNotificationConfigurations
              .isActivated
          "
          class="tim-checkbox"
          >per e-Mail
        </mat-checkbox>
        <mat-checkbox
          [(ngModel)]="
            settingsoriginator.state.eventNotificationConfigurations.forMessages
              .viaTaskManagment
          "
          [disabled]="
            !settingsoriginator.state.eventNotificationConfigurations
              .isActivated
          "
          class="tim-checkbox"
          >Aufgabenmanagement
        </mat-checkbox>
      </div>
    </div>
  </div> ---------------------------------->
  <app-settings-slider
    [attr.data-testid]="testIds.deletePeriodSlider"
    [(modelNg)]="settingsOriginator.state.deletionPeriodConfigurations.isActivated"
    [choiceDescriptor]="settingsOriginator.state.deletionPeriodConfigurations.isActivated ? 'aktiv' : 'inaktiv'"
    settingDescriptor="1. Erinnerung an Raumlöschung"></app-settings-slider>
  <span class="reminder-time">Erinnerungszeit</span>
  <div class="reminder_container">
    <input
      [(ngModel)]="settingsOriginator.state.deletionPeriodConfigurations.timeUntilDeletion"
      [disabled]="!settingsOriginator.state.deletionPeriodConfigurations.isActivated"
      [value]="settingsOriginator.state.deletionPeriodConfigurations.timeUntilDeletion"
      class="reminder-time_input"
      [attr.data-testid]="testIds.inputDeletiontime"
      min="0"
      (keydown)="preventInvalidNumberInput($event)" />
    <span class="reminder-time_label">Monate nach Inaktivität</span>
  </div>
  @if (
    settingsOriginator.state.deletionPeriodConfigurations.isActivated &&
    settingsOriginator.state.deletionPeriodConfigurations.timeUntilDeletion > maxDeletionPeriod!
  ) {
    <span class="error-message">Die gesetzte Zeit darf nicht mehr als 24 Monate betragen.</span>
  }
  <div class="save-btn-container">
    <app-button
      [dataTestId]="testIds.saveSettingsButton"
      (clicked)="saveSettings()"
      [isPrimary]="true"
      [isDisabled]="
        settingsOriginator.state.deletionPeriodConfigurations.isActivated &&
        settingsOriginator.state.deletionPeriodConfigurations.timeUntilDeletion > maxDeletionPeriod!
      "
      class="save-btn"
      text="Speichern"></app-button>
  </div>
</div>
